import { combineReducers } from "redux";

import lead from "../features/admin/leads/Slice";

const leads = combineReducers({
  lead,
});

export default leads;
